import { AccountPayable } from "./AccountPayable";
import { LoginCorporationData } from "./Login";

/**
 * ユーザーのスキル
 */
export interface UserSkill {
  type:
    | "1" // 言語
    | "2"; // ツール
  name: string;
  exp: number;
}

/**
 * アイコン更新フラグ
 */
export type IconUpdateFlag =
  | "0" // 更新なし
  | "1" // 更新
  | "2"; // 削除

/**
 * コードテーマ
 */
export type CodeTheme =
  | '1' // ダークモード
  | '2' // ライトモード

export const DarkMode = '1' as CodeTheme;
export const LightMode = '2' as CodeTheme;

/**
 * オファーメール
 */
export type OfferMail =
| '1' // 受信する
| '2' // 受信しない

export const Send = '1' as OfferMail;
export const NoSend = '2' as OfferMail;

/**
 * 通報内容
 */
 export type ReportType =
 | "1" // 性的、わいせつな表現
 | "2" // 反社会的、暴力的である
 | "3" // 出会い目的、勧誘
 | "4" // 迷惑行為
 | "5" // スパムや詐欺
 | "6" // プライバシーに関する内容を含む
 | "7" // 取引の放置
 | "8" // その他

 export const Type1 = '1' as ReportType;

// view のユーザー型
export interface UserProfile {
  id: string;
  userId: string;
  mailAddress: string;
  iconUrl: string;
  nickname: string;
  skill: {
    language: UserSkill[];
    tool: UserSkill[];
  };
  codeTheme: CodeTheme;
  isTwoFactor: boolean;
  isFreeTime: boolean;
  registeredCreditCard: boolean;
  accountStatus: string;
  userCategory: string;
  corporateUserCategory: string;
  corporationsData: LoginCorporationData;
}

// ユーザー情報取得レスポンス
export interface GetUserProfileResponse {
  id: string;
  userId: string;
  mailAddress: string;
  phoneNumber: string;
  isTwoFactor: boolean;
  iconUrl: string;
  goodEvaluation: number;
  badEvaluation: number;
  completedDealsCount: number;
  nickname: string;
  selfIntroduction: string;
  skills: UserSkill[];
  twitterUsername: string;
  githubUsername: string;
  websiteUrl: string;
  publishedMailAddress: string;
  affiliation: string;
  affiliationUrl: string;
  codeTheme: CodeTheme;
  offerMail: OfferMail;
  isFreeTime: boolean;
  accountPayable: AccountPayable;
  registeredCreditCard: boolean;
  accountStatus: string;
  userCategory: string;
  corporateUserCategory: string;
  corporationsData: LoginCorporationData;
}

// 他ユーザー取得レスポンス
export interface GetUsersResponse {
  userId: string;
  iconUrl: string;
  goodEvaluation: number;
  badEvaluation: number;
  completedDealsCount: number;
  nickname: string;
  selfIntroduction: string;
  skill: UserSkill[];
  twitterUsername: string;
  githubUsername: string;
  websiteUrl: string;
  publishedMailAddress: string;
  affiliation: string;
  affiliationUrl: string;
  // TODO: APIレスポンスに存在しない
  lastAccess: Date;
}

// ユーザー情報更新リクエスト
export interface UpdateUserProfileRequest {
  icon: File | null;
  iconUpdateFlag: IconUpdateFlag | null;
  nickname: string | null;
  selfIntroduction: string | null;
  skills: UserSkill[];
  twitterUsername: string | null;
  githubUsername: string | null;
  websiteUrl: string | null;
  publishedMailAddress: string | null;
  affiliation: string | null;
  affiliationUrl: string | null;
  codeTheme: CodeTheme | null;
  offerMail: OfferMail | null;
}

// ユーザー情報更新レスポンス
export interface UpdateUserProfileResponse {
  iconUrl: string;
  nickname: string;
  selfIntroduction: string;
  skills: UserSkill[];
  twitterUsername: string;
  githubUsername: string;
  websiteUrl: string;
  publishedMailAddress: string;
  affiliation: string;
  affiliationUrl: string;
  codeTheme: CodeTheme;
}


// ユーザー情報更新（法人）リクエスト
export interface UpdateCorporateUserProfileRequest {
  nickname: string | null;
  codeTheme: CodeTheme | null;
}

// 決済情報登録リクエスト
export interface CreatePaymentInformationRequest {
  cardToken: string
}

// パスワード変更リクエスト
export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}

// メールアドレス変更リクエスト
export interface ChangeMailAddressRequest {
  newMailAddress: string;
}

// 電話番号登録リクエスト
export interface RegisterPhoneNumberRequest {
  id: string;
  phoneNumber: string;
}

// 電話番号取得リクエスト
export interface GetAuthPhoneNumberRequest {
  userId: string;
}

// 電話番号取得レスポンス
export interface GetAuthPhoneNumberResponse {
  phoneNumber: string;
}

// 電話番号変更用認証コードの発行リクエスト
export interface SendAuthCode {
  userId: string;
  phoneNumber: string;
  purpose:string;
}

// メールによる認証コードの再発行リクエスト
export interface SendMailAuthCode {
  mailAddress: string;
}

// 電話番号変更用リクエスト
export interface ChangePhoneNumberRequest {
  newPhoneNumber: string;
}

// 新規会員登録時ユーザーId取得リクエスト
export interface GetUserIdRequest {
  id: string;
}

// 新規会員登録時ユーザーId取得レスポンス
export interface GetUserIdResponse {
  userId: string;
}

// 電話番号重複チェックリクエスト
export interface CheckAuthPhoneNumberRequest {
  userId:string;
  inputPhoneNumber:string;
}

// 電話番号重複レスポンス
export interface CheckAuthPhoneNumberResponse {
  isDuplicate:boolean;
  message:string;
}